/**
 * Config ActionTypes
 */
export enum Actions {
  SET_CONFIG_PARAMS = "SET_CONFIG_PARAMS",
  SET_CONFIG_INITIALIZED = "SET_CONFIG_INITIALIZED",
  SET_DISABLE_PAY_BUTTON = "SET_DISABLE_PAY_BUTTON",
}



// WEBPACK FOOTER //
// ./src/store/Actions.tsx